import { ReactNode, createContext, useContext, useState } from 'react'
import { DateRange } from 'types'

export type AnalyticsStatus = 'loading' | 'loaded' | 'empty' | 'filtered-empty'

interface WorkspaceAnalyticsContextType {
  status: AnalyticsStatus
  setStatus: (status: AnalyticsStatus) => void
  dateRange?: DateRange
  setDateRange: (range?: DateRange) => void
}

const WorkspaceAnalyticsContext = createContext<WorkspaceAnalyticsContextType>({} as any)

interface Props {
  children: ReactNode
}

export function WorkspaceAnalyticsProvider({ children }: Props) {
  const [status, setStatus] = useState<AnalyticsStatus>('loading')
  const [dateRange, setDateRange] = useState<DateRange>()

  return (
    <WorkspaceAnalyticsContext.Provider value={{ status, setStatus, dateRange, setDateRange }}>
      {children}
    </WorkspaceAnalyticsContext.Provider>
  )
}

export function useWorkspaceAnalytics() {
  const context = useContext(WorkspaceAnalyticsContext)
  if (context === undefined) {
    throw new Error('useWorkspaceAnalytics must be used within a WorkspaceAnalyticsProvider')
  }
  return context
}
